

import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export default <LoadingOutlined style={{ fontSize: 24 }} />;
